// Import and export hook
import { useUpdateAllEquipmentTreeForScanner as _useUpdateAllEquipmentTreeForScanner } from './hooks/useUpdateAllEquipmentTreeForScanner'

export const useUpdateAllEquipmentTreeForScanner =
  _useUpdateAllEquipmentTreeForScanner
